import React from "react";
import { toFa } from "@soheil/core";
import { haptic } from "../platform/telegram";

export function Check({ done }: { done: boolean }) {
  return (
    <span className="check" data-done={done ? "1" : "0"}>
      <svg viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5" /></svg>
    </span>
  );
}

export function Btn({
  children, onClick, variant = "primary", disabled, type = "button", full,
}: {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: "primary" | "ghost" | "quiet";
  disabled?: boolean;
  type?: "button" | "submit";
  full?: boolean;
}) {
  return (
    <button
      type={type}
      className={`btn btn-${variant}${full ? " btn-full" : ""}`}
      disabled={disabled}
      onClick={onClick ? () => { haptic("tap"); onClick(); } : undefined}
    >
      {children}
    </button>
  );
}

export function Stat({ value, label, tone }: { value: string | number; label: string; tone?: "gold" | "sage" | "lilac" }) {
  return (
    <div className={`stat${tone ? ` stat-${tone}` : ""}`}>
      <b>{typeof value === "number" ? toFa(value) : value}</b>
      <span>{label}</span>
    </div>
  );
}

export function Bar({ pct, tone = "gold" }: { pct: number; tone?: "gold" | "sage" | "lilac" }) {
  return (
    <div className="bar">
      <i style={{ width: `${Math.max(0, Math.min(100, pct))}%` }} data-tone={tone} />
    </div>
  );
}

export function Empty({ icon, title, hint }: { icon: string; title: string; hint?: string }) {
  return (
    <div className="empty">
      <span className="empty-icon" aria-hidden="true">{icon}</span>
      <b>{title}</b>
      {hint && <p>{hint}</p>}
    </div>
  );
}

export function Sheet({
  open, onClose, title, children,
}: { open: boolean; onClose: () => void; title: string; children: React.ReactNode }) {
  if (!open) return null;
  return (
    <div className="sheet-wrap" role="dialog" aria-modal="true" aria-label={title}>
      <button className="sheet-scrim" onClick={onClose} aria-label="بستن" />
      <div className="sheet">
        <div className="sheet-head">
          <b>{title}</b>
          <button className="sheet-x" onClick={onClose} aria-label="بستن">
            <svg viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12" /></svg>
          </button>
        </div>
        <div className="sheet-body">{children}</div>
      </div>
    </div>
  );
}
